import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { History } from "lucide-react";

const SOURCE = { manual: "Manual", import: "Spreadsheet import", bulk: "Bulk add", system: "System" };
export const sourceLabel = (s) => SOURCE[s] || "—";
export const when = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");

export function QuestionActivity({ id }) {
  const { data } = useQuery({ queryKey: ["admin-activity", id], queryFn: async () => (await api.get(`/admin/questions/${id}/activity`)).data });
  if (!data) return null;
  return (
    <section className="space-y-4 rounded-2xl border border-border bg-card p-5" data-testid="question-activity">
      <h3 className="flex items-center gap-2 font-serif text-xl font-semibold text-foreground"><History className="h-5 w-5 text-gold" /> Activity</h3>
      <dl className="grid gap-2 text-sm sm:grid-cols-2">
        <div><dt className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">Created</dt>
          <dd data-testid="activity-created">{when(data.created_at)} · {sourceLabel(data.created_source)}</dd></div>
        <div><dt className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">Last updated</dt>
          <dd data-testid="activity-updated">{when(data.updated_at)} · {sourceLabel(data.last_change_source)}</dd></div>
      </dl>
      {data.activity.length ? (
        <ol className="divide-y divide-border rounded-xl border border-border" data-testid="activity-list">
          {data.activity.map((a, i) => (
            <li key={`${a.at}-${i}`} className="flex flex-wrap items-baseline gap-x-3 gap-y-1 px-4 py-2.5 text-sm" data-testid={`activity-row-${i}`}>
              <span className="font-mono text-xs text-muted-foreground">{when(a.at)}</span>
              <span className="font-semibold capitalize text-foreground">{a.action}</span>
              <span className="rounded-full bg-muted px-2 py-0.5 text-[11px] text-muted-foreground">{sourceLabel(a.source)}</span>
              {a.actor && <span className="text-xs text-muted-foreground">by {a.actor}</span>}
              {a.detail && <span className="w-full text-xs text-muted-foreground">{a.detail}</span>}
            </li>
          ))}
        </ol>
      ) : (
        <p className="text-sm text-muted-foreground">No recorded changes yet. History is tracked from now on.</p>
      )}
    </section>
  );
}
